module.exports = __webpack_public_path__ + "media/assets/images/blog/potenziale_chiamate_perse-aa8aff4c0e184ea789228e9641bce8ef.png";